
import type { LegalModuleConfig } from "../types";
import React from "react";
import { getContractTypeLabel } from "../../../constants/contractTypes";

export const contractModuleConfig: LegalModuleConfig = {
  id: "contracts",
  title: "合約系統管理",
  collection: "legal_contracts",
  searchableFields: ["title", "contractNo", "counterparty", "notes"],
  formSchema: "ContractForm",
  importMapping: "contracts",
  exportMapping: "contracts",
  canEdit: true,
  columns: [
    { key: "contractNo", label: "合約編號", width: 120, type: "text" },
    { key: "title", label: "標題", width: 200, type: "text" },
    { 
      key: "contractType", 
      label: "合約類型", 
      width: 120, 
      type: "text",
      render: (row: any) => getContractTypeLabel(row.contractType) 
    },
    { key: "counterparty", label: "對造", width: 150, type: "text" },
    { key: "department", label: "部門", width: 100, type: "text" },
    { 
      key: "period", 
      label: "起訖日", 
      width: 180,
      render: (row: any) => {
        // Normalizing date format to YYYY-MM-DD
        const fmt = (d: string) => d ? d.replace(/\//g, "-").slice(0, 10) : "";
        
        const start = fmt(row.periodStart || row.signDate);
        const end = fmt(row.periodEnd);
        
        if (!start) return React.createElement("span", { style: { color: "var(--muted)" } }, "未設定");
        
        if (!end) {
           return React.createElement("span", { style: { color: "#a5b4fc" } }, `${start} ~ 永久`);
        }
        return `${start} ~ ${end}`;
      }
    },
    { key: "status", label: "狀態", width: 100, type: "badge" },
    { 
      key: "riskLevel", 
      label: "風險", 
      width: 80,
      render: (row: any) => {
        const color = row.riskLevel === 'high' ? 'var(--danger)' : row.riskLevel === 'medium' ? '#d97706' : 'var(--muted)';
        return React.createElement("span", { style: { color } }, row.riskLevel === 'high' ? '高' : row.riskLevel === 'medium' ? '中' : '低');
      }
    }
  ]
};
